<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("add") }}
          </button>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditCategoryModal"
          >
            {{ $t("add_category") }}
          </button>
          <a href="#pdfdownloadButton" @click="generateReport" class="btn btn-primary">PDF
            <app-icon name="download"/>
          </a>
          <br>
          <label class="mt-2" for="">Filter Document By Category Name</label>
        </div>
      </div>
    </div>

    <VueHtml2pdf
        :show-layout="false"
        :float-layout="false"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="2400"
        :filename="pageTitle"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="100%"
        ref="html2Pdf"

    >

      <section slot="pdf-content">
        <div class="col-sm-12 col-md-6">
          <app-breadcrumb
              :page-title="pageTitle"
              :directory="$t('datatables')"
              :icon="'grid'"
          />
          <h5>Dated: {{ currentDateTime }}</h5>
        </div>
    <app-table :id="tableId" :options="options" @action="getListAction" />
      </section>
    </VueHtml2pdf>

    <mydocument-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :customerCompany="customerCompany"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <mydocument-viewmodal
      v-if="isViewModalActive"
      :id="id"
      @close-modal="closeViewModal"
    />

    <document-category-addmodal
      v-if="isAddEditCategoryModalActive"
      :table-id="tableId"
      :caregoryId="category_id"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditCategoryModal"
    />
    <!-- <file-upload-modal
      v-if="isFileUploadModal"
      :id="id"
      @close-modal="closeFileUploadModal"
    /> -->
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";

export default {
  extends: CoreLibrary,
  name: "RecordsTable",
  mixins: [TableHelpers],
  props: {
    active: Number,
    customerCompany: {},
  },
  data() {
    return {
      pageTitle: this.getPageTitle(),
      pack_id:0,
      FormViewModal: false,
      FormBuilderModal: false,
      id: 0,
      currentDateTime: new Date().toJSON().slice(0,10).replace(/-/g,'/'),
      isFormAssignModalActive: false,
      isAddEditModalActive: false,
      isAddEditCategoryModalActive: false,
      isViewModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: this.getActionUrl(),
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("type"),
            type: "custom-html",
            key: "type",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("document_name"),
            type: "custom-html",
            key: "name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("expiry_date"),
            type: "custom-html",
            key: "expiry_date",
            modifier: (value) => {
              return `<span>${this.$t(value ?? '---')}</span>`;
            },
          },
          {
            title: this.$t("category"),
            type: "custom-html",
            key: "document_category",
            modifier: (value) => {
              return `<span>${this.$t(value != null ? value.name : '---')}</span>`;
            },
          },
          {
            title: this.$t("expiry_status"),
            type: "custom-html",
            key: "expiry_date",
            modifier: (value) => {
              if (value){
                const date1 = new Date(value);
                const date2 = new Date();
                // One day in milliseconds
                const oneDay = 1000 * 60 * 60 * 24;
                // Calculating the time difference between two dates
                const diffInTime = date1.getTime() - date2.getTime();
                // Calculating the no. of days between two dates
                const diffInDays = Math.round(diffInTime / oneDay);

                if (diffInDays <= 20 && diffInDays >= 11) {
                  return `<span class="badge badge-sm badge-pill badge-warning">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;

                }
                else if(diffInDays <= 10) {
                  if (diffInDays < 1) {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        'Document Expired'
                    )}</span>`;
                  }
                  else {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        diffInDays+' Days left'
                    )}</span>`;
                  }

                }
                else {
                  return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;
                }
              }else{
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                    'N/A'
                )}</span>`;
              }


            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "demo-delete",
          },
          {
            title: this.$t("view"),
            icon: "file-plus",
            type: "none",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    generateReport(event) {
      this.$toastr.s('PDF generation is in progress, Please wait.');

      this.$refs.html2Pdf.generatePdf();

    },
    onProgress(event) {

    },
    beforeDownload(obj) {

    },
    hasDownloaded(obj) {
      this.$toastr.s('File Downloaded');
    },



    getPageTitle() {
      let pageTitle = 'My Records';
      let customerCompany = this.customerCompany;
      if(customerCompany){
        pageTitle =  'Records For '+ customerCompany.company_name;
      }
      return pageTitle;
    },
    openAddEditCategoryModal() {
      this.category_id = 0;
      this.isAddEditCategoryModalActive = true;
    },
    closeAddEditCategoryModal() {
      $("#demo-add-edit-category-Modal").modal("hide");
      this.isAddEditCategoryModalActive = false;
      this.reSetData();
    },
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    openViewModal() {
      this.isViewModalActive = true;
    },
    closeViewModal() {
      $("#demo-view-Modal").modal("hide");
      this.isViewModalActive = false;
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.MYDOCUMENT_SHOW}/${rowData.id}`;
        this.openAddEditModal();
      } else if (actionObj.title == this.$t("view")) {
        this.id = rowData.id;
        this.openViewModal();
      }
      // else if (actionObj.title == this.$t("test")) {
      //   this.isFileUploadModal = true;
      // }
    },
    // closeFileUploadModal() {
    //   this.isFileUploadModal = false;
    // },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.MYDOCUMENT_DELETE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    getActionUrl() {
      let customerCompany = this.customerCompany;
      let url = actions.MYDOCUMENT_LIST
      if(customerCompany && customerCompany?.company_admin?.id){
        url = actions.MYDOCUMENT_LIST + '/' + this.customerCompany.company_admin.id
      }
      return url;
    }
  },
  mounted() {

    var user_id = this.$store.state.userCompanyProfile.dataProfile.id;
    if (user_id != null) {
      this.options.url = actions.MYDOCUMENT_LIST+'?user_id=' + user_id
    }
  },

};
</script>